Vue.component('navigation-toggler', require('./../src/components/Navigation/Toggler'));
Vue.component('navigation-wrapper', require('./../src/components/Navigation/Wrapper'));

Vue.component('cookie-consent', require('./../src/components/Cookie/CookieConsent'));
Vue.component('cookie-setup', require('./../src/components/Cookie/CookieSetup'));
Vue.component('share-buttons', require('./../src/components/ShareButtons'));
Vue.component('search-form', require('./../src/components/Search/Form'));
Vue.component('ssd-paginator', require('./../src/components/Paginator/Select'));

Vue.component('change-reveal', require('./../src/components/Reveal/Change'));
Vue.component('toggle-reveal', require('./../src/components/Reveal/Toggle'));
Vue.component('accordion', require('./../src/components/Reveal/Accordion'));


// WEBPACK FOOTER //
// ./resources/js/front/components.js